import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Body2,
  Bold,
  Display,
  FlexDirection,
  AlignItems,
  Color,
} from '@gousto-internal/citrus-react'

import { RafDiscountStep } from './RafDiscountStep'

const YourFriendGetsContainer = styled(Box)`
  gap: 28px;
  flex: 1;

  @media (max-width: 1023px) {
    gap: 16px;
  }
`

interface RafFriendGetsDiscountsProps {
  firstBoxDiscount: string
  secondBoxDiscount?: string
  firstMonthDiscount: string
  discountDuration: string
}

export const RafFriendGetsDiscounts: React.FC<RafFriendGetsDiscountsProps> = ({
  firstBoxDiscount,
  secondBoxDiscount,
  firstMonthDiscount,
  discountDuration,
}) => (
  <YourFriendGetsContainer
    display={Display.Flex}
    alignItems={AlignItems.Center}
    flexDirection={FlexDirection.Column}
  >
    <Body2 color={Color.ColdGrey_800} size={4}>
      <Bold>Your friends get</Bold>
    </Body2>
    <Box display="flex" flexDirection={FlexDirection.Row} alignItems={AlignItems.FlexStart} gap={4}>
      <RafDiscountStep
        discount={firstBoxDiscount}
        description={
          <>
            their first <br /> box
          </>
        }
        bgColor={Color.ColdGrey_800}
      />
      {secondBoxDiscount && (
        <RafDiscountStep
          discount={secondBoxDiscount}
          description={
            <>
              their <br /> second box
            </>
          }
          bgColor={Color.ColdGrey_600}
        />
      )}
      <RafDiscountStep
        discount={firstMonthDiscount}
        description={
          <>
            their first <br /> {discountDuration}
          </>
        }
        bgColor={Color.ColdGrey_500}
      />
    </Box>
  </YourFriendGetsContainer>
)
